/**
 * Tickets Module Routes — list + detail (PRD 1, EPIC 1.1, Story 1.1.5).
 *
 * Permissions follow V1/backend/app/db/seeds/tickets_permissions_seed.py:
 *   - tickets:read (used here for both routes)
 *   - tickets:create (used by the create wizard, future story)
 *   - tickets:update (PATCH endpoints)
 *   - tickets:delete (admin only)
 *
 * Create-form, RICE editor and status-change UI ship in later stories.
 */

import { lazy } from "react";

import { ModuleRoutes } from "../types";


const TicketsPage = lazy(() => import("@/pages/tickets/TicketsPage"));
const TicketDetailPage = lazy(() => import("@/pages/tickets/TicketDetailPage"));


export const ticketsRoutes: ModuleRoutes = {
  moduleId: "tickets",
  basePath: "/tickets",
  routes: [
    {
      path: "/tickets",
      element: <TicketsPage />,
      permission: { resource: "tickets", action: "read" },
    },
    {
      path: "/tickets/:id",
      element: <TicketDetailPage />,
      permission: { resource: "tickets", action: "read" },
    },
  ],
};
